//used in multiple files...
const Index = {
    formTitles: {
        profilePhoto: {
            title: 'Foto de perfil',
            description: 'Agrega una foto para tu cuenta.',
            updateTitle: 'Sube una foto desde tu computadora',
        },
        name: 'Nombre',
        fullname: 'Nombre completo',
        firstname: 'Nombre de pila',
        lastname: 'Apellido',
        username: 'Nombre de usuario',
        email: 'Dirección de correo electrónico',
        emailUsername: 'Correo electrónico',
        yourEmail: 'Tu correo electrónico',
        zipcode: 'Código postal',
        race: 'Etnicidad',
        birthdate: 'Cumpleaños',
        employmentStatus: 'Estado de Empleo',
        gender: 'Género',
        password: {
            title: 'Contraseña',
            placeholder: 'Contraseña actual',
            newPassword: 'Nueva contraseña',
            setPassword: 'Establecer contraseña',
            confirmPassword: 'Confirmar contraseña',
            updatePassword: 'Actualiza contraseña',
        },
        skip: 'Saltar',
        andUseAnotherEmail: 'y usar otro correo electrónico',
        caregiverEmail: 'Correo electrónico del cuidador',
        caregiverEmailPlaceholder: 'Introduce la dirección de correo electrónico del cuidador',
        agreeLegalStart: 'Al hacer clic en "Continuar", reconozco lo',
        agreeLegalEnd: 'y acepto los',
        agreeLegalPrivacyLabel: 'Política de privacidad',
        agreeLegalTosLabel: 'Condiciones de uso',
    },
    buttons: {
        logout: 'Cerrar sesión',
        login: 'Iniciar sesión',
        continue: 'Continuar',
        edit: 'Editar',
        accept: 'Aceptar',
        decline: 'Rechazar',
        remove: 'Eliminar',
        save: 'Salvar',
        cancel: 'Cancelar',
        manageAccount: 'Gestiona tu cuenta',
        signOut: 'Desconectar',
        addNew: 'Añadir Nueva',
        resend: 'Reenviar',
        accountSignUp: 'No tienes una cuenta? Regístrate',
        forgotPassword: 'Olvidé mi contraseña',
        forgotPasswordShort: 'Has olvidado tu contraseña',
        existingAccountSignIn: 'Ya tienes una cuenta? Inicia sesión',
        update: 'Actualizar',
        send: 'Enviar',
        back: 'Atrás',
        selectAll: 'Seleccionar todo',
        startWatching: 'Empezar a mirar',
        next: 'Siguiente',
        getResources: 'Obtener recursos',
        continueToResources: 'Continuar con los recursos',

    },
};

const FormTranslations = Object.assign(Index)

export default FormTranslations;
